import { API, constructApiUrl } from '../apis.config'
import { restApiClientBlob } from '../rest-api-client'

const redirectToPreauthorizationPage = (response: Blob) => {
  const url = URL.createObjectURL(response)
  window.location.href = url // Redirect the user to the generated HTML page
  return response
}

export const preauthorize = async ({
  enrollmentId,
  propositionId
}: {
  enrollmentId: number
  propositionId: number
}) => {
  const response = await restApiClientBlob
    .url(constructApiUrl(API.enrollments.preauthorize.url, { id: enrollmentId, propositionId }))
    .post({ type: 'DEPOSIT' })

  return redirectToPreauthorizationPage(response)
}

// an OTO Individual enrollment has no mainProposition: its preauthorization only needs the
// enrollment
export const preauthorizeOtoIndividual = async ({ enrollmentId }: { enrollmentId: number }) => {
  const response = await restApiClientBlob
    .url(constructApiUrl(API.enrollments.preauthorizeOtoIndividual.url, { id: enrollmentId }))
    .post({ type: 'DEPOSIT' })

  return redirectToPreauthorizationPage(response)
}
